export default __webpack_public_path__ + "static/media/setas.eed4fec4.png";